import { render } from "./PolicyDocuments.vue?vue&type=template&id=ef76c948&ts=true"
import script from "./PolicyDocuments.vue?vue&type=script&lang=ts"
export * from "./PolicyDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PolicyDocuments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef76c948"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef76c948', __exports__)) {
    api.reload('ef76c948', __exports__)
  }
  
  module.hot.accept("./PolicyDocuments.vue?vue&type=template&id=ef76c948&ts=true", () => {
    api.rerender('ef76c948', render)
  })

}


export default __exports__